export enum TimesheetStatusEnum {
  NOVO = "Novo",
  EDITADO = "Editado",
  ENVIADO = "Enviado",
  APROVADO = "Aprovado",
  NAO_APROVADO = "Não Aprovado",
  CANCELADO = "Cancelado",
}
